<div class="flex flex-column gap-3">

    <p-messages *ngIf="case && !hasDamageType" severity="warn">
        <ng-template pTemplate>
            <div>No se pueden solicitar videoperitaciones porque el expediente no tiene tipo de daño asignado.</div>
        </ng-template>
    </p-messages>

    <!-- Solicitar nueva -->
    <p-panel header="Solicitar nueva videoperitación">
        <div class="flex align-items-center gap-2">
            <div class="input-field">
                <p-dropdown
                    [options]="flows"
                    optionLabel="name"
                    optionValue="flowId"
                    [(ngModel)]="selectedFlowId"
                    placeholder="Selecciona un flujo"
                    appendTo="body"
                    [disabled]="!hasDamageType"
                    [style]="{'min-width': '250px'}">
                </p-dropdown>
            </div>
            <div class="input-field">
                <p-button
                    label="Solicitar"
                    icon="pi pi-send"
                    [loading]="requesting"
                    [disabled]="!selectedFlowId || !hasDamageType"
                    (click)="requestSession()">
                </p-button>
            </div>
        </div>
    </p-panel>

    <!-- Listado -->
    <p-confirmDialog appendTo="body"></p-confirmDialog>
    <p-table
        [value]="sessions"
        [loading]="loading"
        [scrollable]="true"
        scrollHeight="300px"
        emptyMessage="No hay videoperitaciones registradas">
        <ng-template pTemplate="header">
            <tr>
                <th>Estado</th>
                <th>Flujo</th>
                <th>F. creación</th>
                <th>F. expiración</th>
                <th>F. sesión</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-session>
            <tr>
                <td>
                    <p-tag *ngIf="noConsent(session)"
                        value="Sin consentimiento" severity="danger">
                    </p-tag>
                    <p-tag *ngIf="!noConsent(session)"
                        [value]="statusLabel(effectiveStatus(session))"
                        [severity]="statusSeverity(session)">
                    </p-tag>
                </td>
                <td>{{ flowName(session.flowId) }}</td>
                <td>{{ session.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ session.expiresAt | date:'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ sessionRange(session) || '-' }}</td>
                <td>
                    <div class="flex justify-content-end gap-2">
                        <p-button
                            *ngIf="!isExpired(session)"
                            icon="pi pi-copy"
                            pTooltip="Copiar URL"
                            (click)="copyUrl(session.url)">
                        </p-button>
                        <p-button
                            *ngIf="session.url && !isExpired(session)"
                            icon="pi pi-envelope"
                            pTooltip="Enviar enlace"
                            (click)="addComunication(session)">
                        </p-button>
                        <p-button
                            icon="pi pi-database"
                            pTooltip="Ver datos recogidos"
                            (click)="openSessionData(session)">
                        </p-button>
                        <p-button
                            *ngIf="session.fileId"
                            icon="pi pi-download"
                            pTooltip="Descargar evidencias"
                            (click)="downloadEvidenceFile(session)">
                        </p-button>
                        <p-button
                            *ngIf="informeFileId(session)"
                            icon="pi pi-file-pdf"
                            pTooltip="Descargar informe pericial"
                            (click)="downloadInformeFile(session)">
                        </p-button>
                        <p-button
                            *ngIf="(session.status || 'new') === 'new' || isExpired(session)"
                            icon="pi pi-trash"
                            severity="danger"
                            pTooltip="Eliminar"
                            [loading]="deleting"
                            (click)="confirmDelete(session)">
                        </p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

</div>
